import { render, staticRenderFns } from "./GeoChart.vue?vue&type=template&id=621af028&"
import script from "./GeoChart.vue?vue&type=script&lang=js&"
export * from "./GeoChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports